import insightsData from "@/data/insights.json";

/**
 * Static insights helpers — replaces the previous /api/insights backend.
 * Content lives in /app/frontend/src/data/insights.json (14 articles).
 *
 * Sorted descending by published_at so the freshest article appears first.
 */
const ALL = [...insightsData].sort((a, b) =>
  String(b.published_at).localeCompare(String(a.published_at))
);

export const listInsights = ({ category, featured } = {}) => {
  let rows = ALL;
  if (category && category !== "All") {
    rows = rows.filter((r) => r.category === category);
  }
  if (typeof featured === "boolean") {
    rows = rows.filter((r) => !!r.featured === featured);
  }
  return rows;
};

export const getInsight = (slug) => ALL.find((r) => r.slug === slug) || null;

export const CATEGORIES = Array.from(new Set(ALL.map((r) => r.category)));

export default { listInsights, getInsight, CATEGORIES };
